// src/graphql/mutations/sendCommand.js
import { gql } from '@apollo/client';

export const SEND_COMMAND = gql`
  mutation sendCommand($id: String!) {
    sendCommand(
      system_id: $id,
      command: "unpair_next"
    ) {
      session_id
    }
  }
`;

